<template>
  <b-modal
    ref="actionsModal"
    header-class="anchor-modal"
    title="What would you like to do?"
    hide-footer
  >
    <b-form-group class="m-2">
      <b-form-radio-group
        name="action"
        v-model="model.action"
        class="radio-list"
        :options="options"
        stacked
      >
      </b-form-radio-group>
    </b-form-group>
    <div class="text-right">
      <b-button
        size="sm"
        class="raised btn-anchor"
        @click="submit"
        :disabled="!this.model.action"
      >
        Next
        <font-awesome-icon icon="chevron-right" />
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import dealsHelper from '@/libs/deals';
import AchPaymentManagerMixin from '@/components/my_deals/actions/ach_payment/resources/AchPaymentManagerMixin';
import DrawManagerMixin from '@/components/my_deals/actions/draw/DrawManagerMixin';
import ChangeOrderMixin from '@/components/my_deals/actions/change_order/ChangeOrderMixin';
import PayoffManagerMixin from '@/components/my_deals/actions/payoff/PayoffManagerMixin';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


library.add(faChevronRight);


export default {
  data() {
    return {
      loan: null,
      model: { action: null },
    };
  },
  mixins: [
    AchPaymentManagerMixin,
    ChangeOrderMixin,
    DrawManagerMixin,
    PayoffManagerMixin,
  ],
  computed: {
    ableToRequestExtension() {
      return dealsHelper.isDealAbleToRequestExtension(this.loan);
    },
    options() {
      if (!this.loan) { return []; }

      const list = [
        {
          value: 'change_order',
          text: 'Change Order Request',
          disabled: !this.isChangeOrderAllowed,
          error: !this.isChangeOrderAllowed ?
            'Make sure you are in compliance with the requirements for Change Order Request.' :
            null,
        },
        {
          value: 'draws',
          text: 'Draw Request',
          disabled: !this.isDrawAllowed,
          error: !this.isDrawAllowed ?
            'Holdback balance should be greater than $ 0.00.' :
            null,
        },
        {
          value: 'payoff',
          text: 'Payoff Request',
          disabled: !this.isPayoffAllowed,
        },
        {
          value: 'extensions',
          disabled: !this.ableToRequestExtension,
          text: 'Extension Request',
        },
        {
          value: 'insurance',
          disabled: false, // we want the borrower to be able to upload at anytime
          text: 'Upload Insurance files',
        },
        {
          value: 'achpayment',
          text: 'One time ACH Interest Payment Request',
          disabled: !this.isAchPaymentAllowed,
        },
      ];

      return list;
    },
  },
  methods: {
    show(loan) {
      this.loan = loan;
      this.model.action = this.options[this.isDrawAllowed ? 0 : 2].value;
      this.$refs.actionsModal.show();
    },
    hide() {
      this.loan = null;
      this.$refs.actionsModal.hide();
    },
    submit() {
      if (this.model.action) {
        this.$router.push({
          name: 'DealDetail',
          params: { loan_id: this.loan.id },
          query: { action: this.model.action },
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/ActionsModal.vue